import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ClubAdminLayout from "../../layouts/ClubAdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import { ClubNavIcon } from "../../layouts/clubNav";
import AttendanceReportPanel from "../../components/reports/AttendanceReportPanel";

/**
 * Rapoarte, pentru clubul si pentru coordonator.
 *
 * The same panel the coach uses. A coordinator sees only the teams of their
 * sports and a club admin sees all of them, but that is decided by the server
 * rather than by this page knowing who is looking.
 */
export default function ClubReports() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  return (
    <ClubAdminLayout>
      <div className="space-y-6">
        <AdminPageHeader
          title={t("admin.reports", "Rapoarte")}
          subtitle={t(
            "admin.reportsSubtitle",
            "Raport de prezență pe lună și pe echipă, cu descărcare sau trimitere pe email."
          )}
          icon={<ClubNavIcon id="reports" className="w-6 h-6" />}
        />
        {/* A team may be handed over from its own page, so the report opens
            on the squad you were just looking at. */}
        <AttendanceReportPanel initialTeamId={searchParams.get("team")} />
      </div>
    </ClubAdminLayout>
  );
}
